<form #f="ngForm">
  <div class="container-fluid px-3 py-4">
    <!-- Warning message if no permission -->
    <div class="row" *ngIf="!hasPermission">
      <div class="col">
        <div class="alert alert-warning mx-0 mt-0 mb-3" role="alert">
          <mat-icon class="align-middle">warning</mat-icon>
          <strong>Access Denied:</strong> You do not have permission to edit safety plan configuration.
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="alert alert-info mx-0 mt-0 mb-2" role="alert">
          <small>In addition to the <b>Details</b> and <b>Documents</b> (see tab above), you can include any of the following in the <b>Main {{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }} {{ utils.getLangTerm('safety-plans.snapshots.plural', 'Snapshots') }}</b>.</small>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">

        <ul class="checklist mb-0">
          <li>
            <mat-checkbox [(ngModel)]="sssp.include_site_noticeboard" name="include_site_noticeboard">Include the <b>Noticeboard</b>.</mat-checkbox>
          </li>

          <li>
            <mat-checkbox [(ngModel)]="sssp.include_site_emergency_evacuation_plan" name="include_site_emergency_evacuation_plan">Include the <b>Emergency Evacuation Plan</b>.</mat-checkbox>
          </li>

          <li>
            <mat-checkbox [(ngModel)]="sssp.include_site_documents" name="include_site_documents">Include the <b>Documents</b>.</mat-checkbox>
          </li>

          <li>
            <mat-checkbox [(ngModel)]="sssp.include_site_contractors" name="include_site_contractors">Include the list of <b>{{ utils.getLangTerm('contractors.plural', 'Contractors') }}</b>.</mat-checkbox>
          </li>

          <li>
            <mat-checkbox [(ngModel)]="sssp.include_site_contractor_sssps" name="include_site_contractor_sssps">Include all <b>Sub-{{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }}</b> documents of {{ utils.getLangTerm('contractors.plural', 'Contractors') }}.</mat-checkbox>
          </li>

          <li>
            <mat-checkbox [(ngModel)]="sssp.include_site_managers" name="include_site_managers">Include the list of <b>Managers</b>.</mat-checkbox>
          </li>

          <li>
            <mat-checkbox [(ngModel)]="sssp.include_site_hazards" name="include_site_hazards">Include the list of <b>Hazards & Risks</b>.</mat-checkbox>
          </li>

          <li>
            <mat-checkbox [(ngModel)]="sssp.include_site_hazardous_substances" name="include_site_hazardous_substances">Include the list of <b>{{ utils.getLangTerm('hazardous-substances.plural', 'Hazardous Substances') }}</b>.</mat-checkbox>
          </li>

          <li>
            <mat-checkbox [(ngModel)]="sssp.include_site_task_analysis" name="include_site_task_analysis">Include the list of <b>{{ utils.getLangTerm('task_analysis_documents.plural', 'Task Analysis Documents') }}</b><i> (Legacy)</i>.</mat-checkbox>
          </li>

          <li>
            <mat-checkbox [(ngModel)]="sssp.include_site_toolbox_talks" name="include_site_toolbox_talks">Include the list of <b>{{ utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks') }}</b>.</mat-checkbox>
          </li>

          <li>
            <mat-checkbox [(ngModel)]="sssp.include_site_qrcodes" name="include_site_qrcodes">Include the list of <b>QR Codes</b>.</mat-checkbox>
          </li>

          <li>
            <mat-checkbox [(ngModel)]="sssp.include_editors" name="include_editors">Include the <b>"Prepared By / Edited By"</b> details.</mat-checkbox>
          </li>

          <li>
            <mat-checkbox [(ngModel)]="sssp.include_site_audits" name="include_site_audits">Include the list of <b>Inspections & Audits</b>.</mat-checkbox>
          </li>

          <li>
            <mat-checkbox [(ngModel)]="sssp.include_site_incidents" name="include_site_incidents">Include the list of <b>Incidents</b>.</mat-checkbox>
          </li>

          <li>
            <mat-checkbox [(ngModel)]="sssp.include_site_safety_observations" name="include_site_safety_observations">Include the list of <b>Safety Observations</b>.</mat-checkbox>
          </li>

          <li>
            <mat-checkbox [(ngModel)]="sssp.include_site_task_analyses_revised" name="include_site_task_analyses_revised">Include the <b>{{ utils.getLangTerm('ta-jsa-swms.list.site-title', 'TA/JSA/SWMS Register') }}</b>.</mat-checkbox>
          </li>

          <li>
            <mat-checkbox [(ngModel)]="sssp.include_site_assets" name="include_site_assets">Include the <b>Asset Register</b>.</mat-checkbox>
          </li>

        </ul>

      </div>

      <div class="col-12 col-md-6">

        <mat-form-field class="full-width my-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Short description of work:</mat-label>
          <textarea
            matInput
            rows="5"
            placeholder="Enter a short description of work here."
            [(ngModel)]="sssp.short_description"
            name="short_description"
            type="text"
            id="short_description"></textarea>
          <mat-hint>
            Enter a short description of work here.
          </mat-hint>
        </mat-form-field>

        <mat-form-field class="full-width mb-0" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Location of work:</mat-label>
          <textarea
            matInput
            rows="5"
            placeholder="Enter the location of work here."
            [(ngModel)]="sssp.location_of_work"
            name="location_of_work"
            type="text"
            id="location_of_work"></textarea>
          <mat-hint>
            Enter the location of work here.
          </mat-hint>
        </mat-form-field>

      </div>
    </div>

  </div>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="px-3 py-2">
    <button 
      type="button" 
      mat-raised-button 
      color="primary" 
      class="my-2 mx-1" 
      (click)="onSave(f)" 
      matTooltip="Save the configuration." 
      matTooltipPosition="above"
      *ngIf="hasPermission">
      <mat-icon>save</mat-icon>
      Save
    </button>
  </mat-dialog-actions>

</form>
